import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import { useEffect, useState } from "react";
import {
	Box,
	Button,
	Chip,
	CircularProgress,
	Grid,
	IconButton,
	InputLabel,
	ListItemIcon,
	ListSubheader,
	Paper,
	Skeleton,
	Typography,
} from "@mui/material";
import { padding, styled } from "@mui/system";
import axios from "axios";
import { GlobalState } from "context/GlobalContext";
import List from "@mui/material/List";
import Modal from "@mui/material/Modal";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import AttributeForm from "./AddOrEditModal/AddOrEditModal";
import AddOrEditModal from "./AddOrEditModal/AddOrEditModal";
import { DeleteRounded, Edit } from "@mui/icons-material";
import SearchBar from "components/ReusableComponents/SearchBar";
import { PimDashboardState } from "context/PimDashboardContext";
import { attrGrpAttrAssocObj, attrValAssocObj } from "./data";
import { ptBR } from "@mui/x-date-pickers";
import {
	attrTableStrColumnsObj,
	atttributeTableColumnsObj,
	constraintsAttrColObj,
	dependencyAttrColObj,
	addOrEditModelAction,
	constraintsOptions,
	attrValTableStrColumnsObj,
	attributGrpColObj,
	attrConditionalDisplayColObj,
} from "components/PimDashboard/data";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { constraints, datatypes, inputTypes } from "data/globalData";
import MultipleSelectInput from "components/PimDashboard/CommonComponents/MultipleSelectInput/MultipleSelectInput";
import TextInputField from "components/PimDashboard/CommonComponents/InputComponents/TextInputField";
import AddAttributeValues from "./AddAttributeValues/AddAttributeValues";
import { render } from "@testing-library/react";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import MandatoryMappingManager from "./MandatoryMappingManager";

// Styled component for resizable box
const ResizableBox = styled(Paper)(({ theme, width }) => ({
	width: width,
	height: "100%", // Set the height as per your requirement
	overflowY: "scroll",
	resize: "horizontal",
	backgroundColor: theme.palette.primary.grey,
}));

const ResizableDivider = styled(Divider)({
	cursor: "ew-resize",
	width: "4px", // Set the width of the divider as per your requirement
});
const RenderChips = ({ values }) => {
	if (values)
		return (
			<Box display="flex" flexWrap="wrap" columnGap="2%">
				{Object.keys(values).map((row) => {
					return <Chip label={row?.split("_").join(" ").toLocaleUpperCase()} />;
				})}
			</Box>
		);
	else return <></>;
};
const ListSubHeader = ({ attrGrp, handleAddFunction }) => {
	return (
		<Box display="flex" justifyContent="space-between" alignItems="end" pl={2}>
			<Typography variant="body2" color={grey[600]}>
				{attrGrp?.name}
			</Typography>
			<IconButton size="small" onClick={() => handleAddFunction(attrGrp)} disabled={attrGrp?.is_main === true}>
				<AddRoundedIcon />
			</IconButton>
		</Box>
	);
};
export const attrColStyle = { width: "20%", height: 50, overflow: "hidden" };
export const dependencyAttrColStyle = { width: "40%", overflow: "hidden" };
const DesignerAttributes = ({ collection }) => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const { attrGroupsWithAttr, setAttrGroupsWithAttr, allAttributes } = PimDashboardState();

	const [attrGroupCollectionState, setAttrGroupCollectionState] = useState({});
	const [attrGroupState, setAttrGroupState] = useState({});
	const [box1Width, setBox1Width] = useState("20%");
	const [box2Width, setBox2Width] = useState("80%");
	const [addOrEditModal, setAddOrEditModal] = useState(false);
	const [modalAction, setModalAction] = useState(addOrEditModelAction.CREATE);

	const [selectedAttribute, setSelectedAttribute] = useState();
	const [selectedAttrGroup, setSelectedAttrGroup] = useState();
	const [mandatoryMappingOpen, setMandatoryMappingOpen] = useState(false);
	console.log(selectedAttribute, "selectedAttribute");

	useEffect(() => {
		const obj = Object.values(attrGroupsWithAttr)
			.filter((row) => row[attrTableStrColumnsObj.collection_type.key] === collection.key)
			.reduce((acc, row) => {
				acc[row.group_id] = row;
				return acc;
			}, {});

		setAttrGroupCollectionState({ ...obj });
		setAttrGroupState({ ...obj });

		// console.log(attrGroupsWithAttr, obj, "smdfjjdsk,kasd");
	}, [attrGroupsWithAttr]);
	const handleResize = (event) => {
		const box1NewWidth = `${event.clientX}px`;
		const box2NewWidth = `${window.innerWidth - event.clientX}px`;
		if (event.clientX < 400 && event.clientX > 150) {
			setBox1Width(box1NewWidth);
			setBox2Width(box2NewWidth);
		}
	};

	const handleRemoveEventListener = () => {
		window.removeEventListener("mousemove", handleResize);
		window.removeEventListener("mouseup", handleRemoveEventListener);
	};
	const handleEditClick = () => {
		setAddOrEditModal(true);
		setModalAction(addOrEditModelAction.UPDATE);
	};
	const handleAttributeSelect = async (attr, attrGrp) => {
		setSelectedAttribute(attr);
		setSelectedAttrGroup(attrGrp);
	};

	function handleSearchSubmit(search) {
		if (search) {
			let newObj = {};
			let regex = new RegExp(search, "i");
			Object.keys(attrGroupCollectionState).forEach((key) => {
				const attributeGrp = { ...attrGroupCollectionState[key] };
				console.log(search);
				if (regex.test(attributeGrp.name)) {
					newObj[attributeGrp?.group_id] = attributeGrp;
				} else {
					attributeGrp[attrGrpAttrAssocObj]?.forEach((attribute) => {
						// console.log(regex.test(attribute.name, "samndm,sfm.fdsdf"));
						if (!newObj[attributeGrp?.group_id]) {
							newObj[attributeGrp?.group_id] = attributeGrp;
						}
						newObj[attributeGrp?.group_id][attrGrpAttrAssocObj] = newObj[attributeGrp?.group_id][
							attrGrpAttrAssocObj
						]?.filter((attr) => attr?.key != attribute.key);
						if (regex.test(attribute.name)) {
							newObj[attributeGrp?.group_id][attrGrpAttrAssocObj]?.push(attribute);
						}
					});
				}
			});
			// console.log(newObj, "newObjnewObj");
			setAttrGroupState(newObj);
		} else setAttrGroupState({ ...attrGroupCollectionState });
	}
	const handleAddAttrFunction = (attrGrp) => {
		setAddOrEditModal(true);
		setSelectedAttrGroup(attrGrp);
		setModalAction(addOrEditModelAction.CREATE);
	};
	const handleAttrValDelete = async (attrValToDel) => {
		try {
			setLoadingOpen(true);
			let attrArr = attrGroupsWithAttr[selectedAttribute[attributGrpColObj.key]][attrGrpAttrAssocObj];
			const res = await axios.delete(`/api/attr_master/delete_attr_val?id=${attrValToDel?.id}`);

			const selectedAttrObj = {
				...selectedAttribute,
				[attrValAssocObj]: selectedAttribute[attrValAssocObj]?.filter((attrVal) => attrVal?.id !== attrValToDel?.id),
				res,
			};
			setSelectedAttribute({ ...selectedAttrObj });
			// setSelectedAttrGroup({
			// 	...selectedAttrGroup,
			// 	[attrGrpAttrAssocObj]: attrArr?.map((row) => {
			// 		if (row.key === selectedAttribute.key) return selectedAttrObj;
			// 		else return row;
			// 	}),
			// });
			setAttrGroupsWithAttr({
				...attrGroupsWithAttr,
				[selectedAttribute[attributGrpColObj.key]]: {
					...attrGroupsWithAttr[selectedAttribute[attributGrpColObj.key]],
					[attrGrpAttrAssocObj]: attrArr?.map((row) => {
						if (row.key === selectedAttribute.key) return selectedAttrObj;
						else return row;
					}),
				},
			});
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Attribute Value Deleted",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		} catch (error) {
			console.log(error);
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
		setModalAction(addOrEditModelAction.CREATE);
	};
	return (
		<Stack sx={{ display: "flex", flexDirection: "row", height: "79vh", width: "100%" }}>
			<ResizableBox width={box1Width} sx={{ position: "relative" }}>
				<Box display={"flex"} p={1} flexWrap={"wrap"}>
					{/* <InputLabel>{"Search"}</InputLabel> */}
					<SearchBar
						placeholder="Search Attribute"
						submitFunction={handleSearchSubmit}
						sx={{
							p: "2px",
						}}
						iconSx={{
							p: "2px",
							pt: 1,
							pb: 1,
						}}
					/>{" "}
				</Box>

				{attrGroupState &&
					Object.values(attrGroupState)
						.sort((a, b) => a.sort_no - b.sort_no)
						.map((attrGrp) => {
							console.log(attrGrp, "attrGrpattrGrp");
							const attributes = attrGrp[attrGrpAttrAssocObj];
							return (
								<List subheader={<ListSubHeader attrGrp={attrGrp} handleAddFunction={handleAddAttrFunction} />}>
									{attributes
										?.sort((a, b) => a.sort_no - b.sort_no)
										.map((attribute, index) => {
											return (
												<ListItem key={index} component="div" disablePadding>
													<ListItemButton
														sx={{ height: "40px" }}
														onClick={() => handleAttributeSelect(attribute, attrGrp)}
														selected={selectedAttribute?.key === attribute.key}>
														<ListItemText
															sx={{ textTransform: "capitalize" }}
															primary={`${attribute.name}`}
														/>
													</ListItemButton>
												</ListItem>
											);
										})}
								</List>
							);
						})}

				{/* <Box position="absolute" bottom={0} left={0} width="100%" sx={{ background: "white" }}>
					<Divider orientation="horizontal" />

					<Button startIcon={<AddRoundedIcon />} fullWidth sx={{ alignItems: "left" }}>
						New Attribute
					</Button>
					<Divider orientation="horizontal" />
					<Button startIcon={<AddRoundedIcon />} fullWidth onClick={handleAddAttrFunction}>
						New Attribute
					</Button>
				</Box> */}
			</ResizableBox>

			<ResizableDivider
				onMouseDown={(event) => {
					window.addEventListener("mousemove", handleResize);
					window.addEventListener("mouseup", handleRemoveEventListener);
				}}
			/>

			<ResizableBox width={box2Width}>
				{selectedAttribute ? (
					<Stack width="100%" boxSizing="border-box" p={1} spacing={1}>
						<Box display="flex" justifyContent="space-between" pl={1} pr={1}>
							<Typography variant="h5" textTransform="capitalize">
								Attribute - {selectedAttribute?.name}
							</Typography>
							<Box>
								<Button variant="contained" size="small" onClick={handleEditClick}>
									Edit
								</Button>
								<Button 
									variant="outlined" 
									size="small" 
									onClick={() => setMandatoryMappingOpen(true)}
									sx={{ ml: 1 }}
								>
									Mandatory Rules
								</Button>
							</Box>
						</Box>
						<Divider orientation="horizontal" />
						<Box display="flex" flexWrap="wrap" columnGap="3%" rowGap="15px" p={1}>
							{/* <Typography variant="body1" width="100%">
								Main Details
							</Typography> */}
							{Object.keys(attrTableStrColumnsObj)?.map((key) => {
								return (
									<Stack {...attrColStyle} key={key}>
										<Typography variant="subtitle2" color={grey[600]}>
											{attrTableStrColumnsObj[key].name}
										</Typography>
										<Typography variant="h6" textTransform={key === "key" ? "lowercase" : "capitalize"}>
											{selectedAttribute[attrTableStrColumnsObj[key].key]
												? selectedAttribute[attrTableStrColumnsObj[key].key]
												: "--"}
										</Typography>
									</Stack>
								);
							})}
							{selectedAttribute && selectedAttrGroup?.data?.[attrConditionalDisplayColObj.key] && (
								<Stack {...attrColStyle}>
									<Typography variant="subtitle2" color={grey[600]}>
										{attrConditionalDisplayColObj?.name}
									</Typography>
									<Typography variant="h6" textTransform="capitalize">
										{selectedAttribute?.data?.[attrConditionalDisplayColObj.key]?.join(",")}
									</Typography>
								</Stack>
							)}
							<Stack {...dependencyAttrColStyle}>
								<Typography variant="subtitle2" color={grey[600]}>
									{dependencyAttrColObj.name}
								</Typography>{" "}
								{selectedAttribute && Object.keys(selectedAttribute[dependencyAttrColObj.key])?.length ? (
									<RenderChips values={selectedAttribute[dependencyAttrColObj.key]} />
								) : (
									<Typography variant="h6" textTransform="capitalize">
										----
									</Typography>
								)}
							</Stack>
							<Stack {...dependencyAttrColStyle}>
								<Typography variant="subtitle2" color={grey[600]}>
									{constraintsAttrColObj.name}
								</Typography>
								{selectedAttribute && Object.keys(selectedAttribute[constraintsAttrColObj.key])?.length ? (
									<RenderChips values={selectedAttribute[constraintsAttrColObj.key]} />
								) : (
									<>----</>
								)}
							</Stack>
						</Box>

						{/* atribute Values */}
						{selectedAttribute[attrTableStrColumnsObj.input_type.key] === inputTypes.SELECT.key ||
						selectedAttribute[attrTableStrColumnsObj.input_type.key] === inputTypes.MULTIPLE_SELECT.key ? (
							<Box p={1} boxSizing="border-box">
								<Divider orientation="horizontal" />

								<Box display="flex">
									<Box width="60%">
										<Typography variant="h6" p={1} width="100%">
											Attribute Values
										</Typography>
										<DataGrid
											rows={selectedAttribute[attrValAssocObj]?.length ? selectedAttribute[attrValAssocObj] : []}
											columns={[
												{
													field: attrValTableStrColumnsObj.value.key,
													headerName: selectedAttribute?.name?.toLocaleUpperCase(),
													width: 150,
													headerAlign: "center",
													align: "center",
												},
												...Object.keys(selectedAttribute[dependencyAttrColObj.key])?.map((attr) => {
													return {
														field: attr,
														headerName: attr.toLocaleUpperCase(),
														width: 150,
														headerAlign: "center",
														align: "center",
														valueGetter: (value, row) => {
															let dependency = row[dependencyAttrColObj.key];
															console.log(dependency, "dependencydependencydependency");
															return dependency && dependency[attr]?.length
																? `${dependency[attr]?.map((row) => row)}`
																: "";
														},
													};
												}),

												{
													headerName: "DELETE",
													width: 150,
													headerAlign: "center",
													align: "center",

													renderCell: (params) => {
														return (
															<Box display="flex" justifyContent="center" alignItems="center">
																<IconButton
																	variant="contained"
																	color="error"
																	disabled={selectedAttribute?.data_type === datatypes.BOOLEAN.key}
																	onClick={() => handleAttrValDelete(params.row)}>
																	<DeleteRounded />
																</IconButton>
															</Box>
														);
													},
												},
											]}
											sx={{
												minHeight: 220,
												maxHeight: 300,
												width: "95%",
												border: "none",
												"& .MuiDataGrid-row": {
													// borderBottom: "1px solid lightgray",
													cursor: "pointer",
													border: "none",
												},
												"& .MuiDataGrid-columnHeader": {
													cursor: "pointer",
													background: grey[300],
												},
												"& .MuiDataGrid-columnHeaders": {
													background: grey[300],
													// mb: 2,
													border: "none",
													borderRadius: 1,
													// padding: "10px 0px",
												},
											}}
											columnHeaderHeight={35}
											rowHeight={40}
											disableRowSelectionOnClick
											pageSizeOptions={[50, 100]}
										/>
									</Box>
									<Box width="38%">
										<AddAttributeValues
											selectedAttribute={selectedAttribute}
											setSelectedAttribute={setSelectedAttribute}
											disableAdd={selectedAttribute?.data_type === datatypes.BOOLEAN.key}
										/>
									</Box>
								</Box>
							</Box>
						) : (
							<></>
						)}
					</Stack>
				) : (
					<></>
				)}
			</ResizableBox>
			<AddOrEditModal
				action={modalAction}
				modalOpen={addOrEditModal}
				setModalOpen={setAddOrEditModal}
				attrData={selectedAttribute}
				setAttrData={setSelectedAttribute}
				setAttrGrpData={setSelectedAttrGroup}
				attrGrpData={selectedAttrGroup}
				collection={collection}
			/>
			{selectedAttribute && allAttributes && (
				<MandatoryMappingManager
					open={mandatoryMappingOpen}
					onClose={() => setMandatoryMappingOpen(false)}
					attribute={selectedAttribute}
					allAttributes={allAttributes}
					onSave={async (updatedAttr) => {
						try {
							setLoadingOpen(true);
							await axios.post('/api/attr_master/update_attr', updatedAttr);
							setSelectedAttribute(updatedAttr);
							setAttrGroupsWithAttr({
								...attrGroupsWithAttr,
								[selectedAttrGroup?.group_id]: {
									...selectedAttrGroup,
									[attrGrpAttrAssocObj]: selectedAttrGroup[attrGrpAttrAssocObj]?.map(row => 
										row.key === updatedAttr.key ? updatedAttr : row
									)
								}
							});
							setMandatoryMappingOpen(false);
							setSnackBarOpen(true);
							setSnackBar({
								...snackBar,
								message: 'Mandatory mappings updated',
								severity: 'success',
								anchorOrigin: { horizontal: 'center', vertical: 'top' }
							});
							setLoadingOpen(false);
						} catch (error) {
							setSnackBarOpen(true);
							setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
							setLoadingOpen(false);
						}
					}}
				/>
			)}
		</Stack>
	);
};

export default DesignerAttributes;
